import OverviewPage from 'components/admin/OverviewPage.vue';
import adminParticipantsRoutes from './core/participants.routes';
import adminEducationRoutes from './core/education.routes';
import adminLibraryRoutes from './core/library.routes';
import adminSettingsRoutes from './core/settings.routes';
import adminDevelopmentRoutes from './core/development.routes';
import adminChatsRoutes from './core/chats.routes';
import adminMiscRoutes from './core/misc.routes';
import adminCoursesRoutes from './core/courses.routes';
import adminOverviewRoutes from './core/overview.routes';

const adminCoreRoutes = [
    { path: '', name: 'admin-index', component: OverviewPage },
    { path: 'desktop/:id?', name: 'desktop', component: () => import('pages/sot.bot.admin/desktop/AdminDesktop.vue') },
    ...adminParticipantsRoutes,
    ...adminEducationRoutes,
    ...adminLibraryRoutes,
    ...adminSettingsRoutes,
    ...adminDevelopmentRoutes,
    ...adminChatsRoutes,
    ...adminMiscRoutes,
    ...adminCoursesRoutes,
    ...adminOverviewRoutes,
];

export default adminCoreRoutes;
